import { ErrorNotification } from 'components/Notification';
import { WrapStrong } from 'components/WrapStrong';
import React, { FC, useEffect } from 'react';
import { translationKeys, useTranslation } from 'services/localization';
import { trackDisplayFailedToUpdatePreferences } from '../../../../services/userActionEvents';
import { ActionNotificationMessageProps } from '../../types';

const ErrorRequest: FC<ActionNotificationMessageProps> = ({ onClose }) => {
  const { translate } = useTranslation();

  useEffect(() => {
    trackDisplayFailedToUpdatePreferences();
  });

  return (
    <ErrorNotification title={translate(translationKeys.NOTIFICATION_ERROR_MESSAGE_TITLE)} onClose={onClose}>
      <p>
        <WrapStrong value={translate(translationKeys.NOTIFICATION_ERROR_MESSAGE_DESCRIPTION)} start={-4} />
      </p>
    </ErrorNotification>
  );
};

export default ErrorRequest;
